import Swiper from "swiper";
import Cookies from "js-cookie";

export default {
  init() {
    // console.log('CENNIK INIT');

    // GET CITY & ZONE from Cookies
    const currentLocation = Cookies.get('pysznafabryka-location');
    const currentHours = Cookies.get('pysznafabryka-hours');

    // SET current city and zone labels
    $('#current-city').html(currentLocation);
    $('#current-zone').html(currentHours);

    // CLICK and change current city
    $('#current-city').on('click', function () {
      $('.miasta-list ul li').removeClass('active');
      $('.province-map-btn').removeClass('active');
      $('#step-1-wojewodztwo-label').addClass('active');
      $('#step-2-miasto-label').removeClass('active');
      $('#city-confirm-btn').attr('disabled', true);
      $('#selected-wojewodztwo-mobile').html('');
      $('#step-1-wojewodztwo-mobile').show();
      $('#selected-wojewodztwo-mobile').hide();
      $('#step-2-miasto-mobile').hide();
      $('#miasta-list').hide();
      $('#wojewodztwa-list').show();
      $('#offcanvas-mobile-menu').offcanvas('hide');
      $('#offcanvas-city').offcanvas('show');
    });

    // MOBILE DIETS SLIDER
    const dietsMobile = new Swiper("#dieta-menu-mobile", {
      slidesPerView: 3,
      loop: true,
      speed: 200,
      centeredSlides: true,
      initialSlide: 0,
      // navigation: {
      //   nextEl: '#button-next',
      //   prevEl: '#button-prev',
      // },
    });

    // Select2 - days switch
    $('.days-switch').select2({
      width: '100%',
      minimumResultsForSearch: -1,
      allowClear: false,
    });

    // DIETS SWITCHING and INIT

    const dietTitleDesktop = $('#diet-title-desktop');
    const dietTitleMobile = $('#diet-title-mobile');

    const dietPrevDesktop = $('#prev-diet-arrow');
    const dietNextDesktop = $('#next-diet-arrow');

    const dietPrevMobile = $('#button-prev');
    const dietNextMobile = $('#button-next');

    function initCennik() {
      // console.log('init CENNIK');
      // set Initial Diet
      const firstDietName = $('.cennik-desktop-diet-item').attr('data-diet-name');
      const firstDietId = $('.cennik-desktop-diet-item').attr('data-page-id');

      $('.cennik-desktop-diet-item[data-diet-position="1"]').addClass('active');
      $('.cennik-mobile-diet-item[data-diet-position="1"]').addClass('active');
      $('.single-diet-cennik-container[data-diet-position="1"]').addClass('active');
      $('.diet-switch-container[data-diet-position="1"]').addClass('active');
      $('.single-diet-cennik-container').addClass('przedzial-1');

      dietTitleDesktop.html('Dieta ' + firstDietName);
      dietTitleMobile.html('Dieta ' + firstDietName);
    }

    initCennik();

    // DIET CLICK
    $('.cennik-desktop-diet-item').click(function() {
      // console.log('DIETA CLICK - DESKTOP');
      const dietName = $(this).attr('data-diet-name');
      const dietId = $(this).attr('data-page-id');
      const dietPosition = $(this).attr('data-diet-position') - 1;
      $('.cennik-desktop-diet-item').removeClass('active');
      $('.cennik-mobile-diet-item').removeClass('active');
      $('.single-diet-cennik-container').removeClass('active');
      $('.diet-switch-container').removeClass('active');
      $(this).addClass('active');
      $('.cennik-desktop-diet-item[data-page-id="' + dietId +'"]').addClass('active');
      $('.cennik-mobile-diet-item[data-page-id="' + dietId +'"]').addClass('active');
      $('.single-diet-cennik-container[data-page-id="' + dietId +'"]').addClass('active');
      $('.diet-switch-container[data-page-id="' + dietId +'"]').addClass('active');
      dietTitleDesktop.html('Dieta ' + dietName);
      dietTitleMobile.html('Dieta ' + dietName);
      dietsMobile.slideToLoop(dietPosition);
    });

    $('.cennik-mobile-diet-item').click(function() {
      // console.log('DIETA CLICK - MOBILE');
      const dietName = $(this).attr('data-diet-name');
      const dietId = $(this).attr('data-page-id');
      const dietPosition = $(this).attr('data-diet-position') - 1;
      // console.log(dietPosition);
      $('.cennik-desktop-diet-item').removeClass('active');
      $('.cennik-mobile-diet-item').removeClass('active');
      $('.single-diet-cennik-container').removeClass('active');
      $('.diet-switch-container').removeClass('active');
      $(this).addClass('active');
      $('.cennik-desktop-diet-item[data-page-id="' + dietId +'"]').addClass('active');
      $('.cennik-mobile-diet-item[data-page-id="' + dietId +'"]').addClass('active');
      $('.single-diet-cennik-container[data-page-id="' + dietId +'"]').addClass('active');
      $('.diet-switch-container[data-page-id="' + dietId +'"]').addClass('active');
      dietTitleDesktop.html('Dieta ' + dietName);
      dietTitleMobile.html('Dieta ' + dietName);
      dietsMobile.slideToLoop(dietPosition);
    });

    // NEXT and PREV CLICKS - DESKTOP
    dietPrevDesktop.click(function() {
      // console.log('DIETA PREV - DESKTOP');
      // GET CURRENT & LAST POSITION
      const dietPosition = parseInt($('.cennik-desktop-diet-item.active').attr('data-diet-position'));
      const lastPosition = $('.cennik-desktop-diet-item:last-child').attr('data-diet-position');
      const sliderPosition = dietPosition -1;
      $('.cennik-desktop-diet-item').removeClass('active');
      $('.cennik-mobile-diet-item').removeClass('active');
      $('.single-diet-cennik-container').removeClass('active');
      $('.diet-switch-container').removeClass('active');
      // SET PREV POSITION ACTIVE - IF FIRST
      if (dietPosition === 1) {
        const dietName = $('.cennik-desktop-diet-item[data-diet-position="' + lastPosition +'"]').attr('data-diet-name');
        $('.cennik-desktop-diet-item[data-diet-position="' + lastPosition +'"]').addClass('active');
        $('.cennik-mobile-diet-item[data-diet-position="' + lastPosition +'"]').addClass('active');
        $('.single-diet-cennik-container[data-diet-position="' + lastPosition +'"]').addClass('active');
        $('.diet-switch-container[data-diet-position="' + lastPosition +'"]').addClass('active');
        dietTitleDesktop.html('Dieta ' + dietName);
        dietTitleMobile.html('Dieta ' + dietName);
        dietsMobile.slideToLoop(sliderPosition);
      } else {
        const dietName = $('.cennik-desktop-diet-item[data-diet-position="' + (dietPosition - 1) +'"]').attr('data-diet-name');
        $('.cennik-desktop-diet-item[data-diet-position="' + (dietPosition - 1) +'"]').addClass('active');
        $('.cennik-mobile-diet-item[data-diet-position="' + (dietPosition - 1) +'"]').addClass('active');
        $('.single-diet-cennik-container[data-diet-position="' + (dietPosition - 1) +'"]').addClass('active');
        $('.diet-switch-container[data-diet-position="' + (dietPosition - 1) +'"]').addClass('active');
        dietTitleDesktop.html('Dieta ' + dietName);
        dietTitleMobile.html('Dieta ' + dietName);
        dietsMobile.slideToLoop(sliderPosition);
      }
    });

    dietNextDesktop.click(function() {
      // console.log('DIETA NEXT - DESKTOP');
      // GET CURRENT & LAST POSITION
      const dietPosition = parseInt($('.cennik-desktop-diet-item.active').attr('data-diet-position'));
      const lastPosition = parseInt($('.cennik-desktop-diet-item:last-child').attr('data-diet-position'));
      const sliderPosition = dietPosition -1;
      // console.log(dietPosition);
      // console.log(lastPosition);
      $('.cennik-desktop-diet-item').removeClass('active');
      $('.cennik-mobile-diet-item').removeClass('active');
      $('.single-diet-cennik-container').removeClass('active');
      $('.diet-switch-container').removeClass('active');
      // SET NEXT POSITION ACTIVE - IF LAST
      if (dietPosition === lastPosition) {
        // console.log('LAST POSITION >> FIRST ACTIVE');
        const dietName = $('.cennik-desktop-diet-item[data-diet-position="1"]').attr('data-diet-name');
        $('.cennik-desktop-diet-item[data-diet-position="1"]').addClass('active');
        $('.cennik-mobile-diet-item[data-diet-position="1"]').addClass('active');
        $('.single-diet-cennik-container[data-diet-position="1"]').addClass('active');
        $('.diet-switch-container[data-diet-position="1"]').addClass('active');
        dietTitleDesktop.html('Dieta ' + dietName);
        dietTitleMobile.html('Dieta ' + dietName);
        dietsMobile.slideToLoop(sliderPosition);
      } else {
        // console.log('ELSE POSITION >> +1 ACTIVE');
        const nextPosition = dietPosition + 1;
        const dietName = $('.cennik-desktop-diet-item[data-diet-position="' + nextPosition +'"]').attr('data-diet-name');
        $('.cennik-desktop-diet-item[data-diet-position="' + nextPosition +'"]').addClass('active');
        $('.cennik-mobile-diet-item[data-diet-position="' + nextPosition +'"]').addClass('active');
        $('.single-diet-cennik-container[data-diet-position="' + nextPosition +'"]').addClass('active');
        $('.diet-switch-container[data-diet-position="' + nextPosition +'"]').addClass('active');
        dietTitleDesktop.html('Dieta ' + dietName);
        dietTitleMobile.html('Dieta ' + dietName);
        dietsMobile.slideToLoop(sliderPosition);
      }
    });

    // NEXT and PREV CLICKS - MOBILE
    dietPrevMobile.click(function() {
      // console.log('DIETA PREV - MOBILE');
      // GET CURRENT & LAST POSITION
      const dietPosition = parseInt($('.cennik-desktop-diet-item.active').attr('data-diet-position'));
      const lastPosition = $('.cennik-desktop-diet-item:last-child').attr('data-diet-position');
      const sliderPosition = dietPosition -1;
      $('.cennik-desktop-diet-item').removeClass('active');
      $('.cennik-mobile-diet-item').removeClass('active');
      $('.single-diet-cennik-container').removeClass('active');
      $('.diet-switch-container').removeClass('active');
      // SET PREV POSITION ACTIVE - IF FIRST
      if (dietPosition === 1) {
        const dietName = $('.cennik-desktop-diet-item[data-diet-position="' + lastPosition +'"]').attr('data-diet-name');
        $('.cennik-desktop-diet-item[data-diet-position="' + lastPosition +'"]').addClass('active');
        $('.cennik-mobile-diet-item[data-diet-position="' + lastPosition +'"]').addClass('active');
        $('.single-diet-cennik-container[data-diet-position="' + lastPosition +'"]').addClass('active');
        $('.diet-switch-container[data-diet-position="' + lastPosition +'"]').addClass('active');
        dietTitleDesktop.html('Dieta ' + dietName);
        dietTitleMobile.html('Dieta ' + dietName);
        $('.cennik-mobile-diet-item.active').click();
      } else {
        const dietName = $('.cennik-desktop-diet-item[data-diet-position="' + (dietPosition - 1) +'"]').attr('data-diet-name');
        $('.cennik-desktop-diet-item[data-diet-position="' + (dietPosition - 1) +'"]').addClass('active');
        $('.cennik-mobile-diet-item[data-diet-position="' + (dietPosition - 1) +'"]').addClass('active');
        $('.single-diet-cennik-container[data-diet-position="' + (dietPosition - 1) +'"]').addClass('active');
        $('.diet-switch-container[data-diet-position="' + (dietPosition - 1) +'"]').addClass('active');
        dietTitleDesktop.html('Dieta ' + dietName);
        dietTitleMobile.html('Dieta ' + dietName);
        $('.cennik-mobile-diet-item.active').click();
      }
    });

    dietNextMobile.click(function() {
      // console.log('DIETA NEXT - MOBILE');
      // GET CURRENT & LAST POSITION
      const dietPosition = parseInt($('.cennik-desktop-diet-item.active').attr('data-diet-position'));
      const lastPosition = parseInt($('.cennik-desktop-diet-item:last-child').attr('data-diet-position'));
      const sliderPosition = dietPosition -1;
      // console.log(dietPosition);
      // console.log(lastPosition);
      $('.cennik-desktop-diet-item').removeClass('active');
      $('.cennik-mobile-diet-item').removeClass('active');
      $('.single-diet-cennik-container').removeClass('active');
      $('.diet-switch-container').removeClass('active');
      // SET NEXT POSITION ACTIVE - IF LAST
      if (dietPosition === lastPosition) {
        // console.log('LAST POSITION >> FIRST ACTIVE');
        const dietName = $('.cennik-desktop-diet-item[data-diet-position="1"]').attr('data-diet-name');
        $('.cennik-desktop-diet-item[data-diet-position="1"]').addClass('active');
        $('.cennik-mobile-diet-item[data-diet-position="1"]').addClass('active');
        $('.single-diet-cennik-container[data-diet-position="1"]').addClass('active');
        $('.diet-switch-container[data-diet-position="1"]').addClass('active');
        dietTitleDesktop.html('Dieta ' + dietName);
        dietTitleMobile.html('Dieta ' + dietName);
        $('.cennik-mobile-diet-item.active').click();
      } else {
        // console.log('ELSE POSITION >> +1 ACTIVE');
        const nextPosition = dietPosition + 1;
        const dietName = $('.cennik-desktop-diet-item[data-diet-position="' + nextPosition +'"]').attr('data-diet-name');
        $('.cennik-desktop-diet-item[data-diet-position="' + nextPosition +'"]').addClass('active');
        $('.cennik-mobile-diet-item[data-diet-position="' + nextPosition +'"]').addClass('active');
        $('.single-diet-cennik-container[data-diet-position="' + nextPosition +'"]').addClass('active');
        $('.diet-switch-container[data-diet-position="' + nextPosition +'"]').addClass('active');
        dietTitleDesktop.html('Dieta ' + dietName);
        dietTitleMobile.html('Dieta ' + dietName);
        $('.cennik-mobile-diet-item.active').click();
      }
    });

    // MOBILE SELECT DAYS
    $('.days-switch').on('select2:select', function () {
      console.log('DAYS SWITCH - MOBILE - BASED on CSS CLASS');
      const daysSelected = $(this).val();
      const dietPosistion = parseInt($(this).parents('.diet-switch-container.active').attr('data-diet-position'));
      console.log(dietPosistion);
      console.log(daysSelected);
      $('#cennik-table-mobile .single-diet-cennik-container[data-diet-position="' + dietPosistion +'"]').removeClass('przedzial-1 przedzial-2 przedzial-3 przedzial-4');
      $('#cennik-table-mobile .single-diet-cennik-container[data-diet-position="' + dietPosistion +'"]').addClass(daysSelected);
    });

  },
}
